module.exports = __webpack_public_path__ + "static/media/04510010-dJSzwSgs.664b2bf7.JPG";